module.exports = __webpack_public_path__ + "img/ince.23eaa0c5.png";